import React, { PropsWithChildren } from 'react'
import { useTableDynamicHeight } from '../../../Helper/EnhancedData/EnhancedDataUtils'
import { SortableTableHead } from './SortableTableHead'
import { TableBody } from './TableBody'
import { TableProps } from './Types'

interface SortableTableProps<T extends object> extends TableProps<T> {
  onSortClick: (sortedRows: T[]) => void
}

export function SortableTable<T extends object> (props: PropsWithChildren<SortableTableProps<T>>): React.JSX.Element {
  const { className, children, rows, scrollThreshold, ...rest } = props
  const isScrollable = !scrollThreshold ? false : rows.length >= scrollThreshold

  const { wrapperRef, dynamicHeight } = useTableDynamicHeight(isScrollable, scrollThreshold, rows)

  return (
    <>
      <div
        ref={wrapperRef}
        className={`table-wrapper ${isScrollable ? 'scrollable' : ''}`}
        style={{ maxHeight: isScrollable ? dynamicHeight : undefined }}
      >
        <table className={`sortable-table ${className || ''}`}>
          <SortableTableHead rows={rows} scrollThreshold={scrollThreshold} {...rest} />
          <TableBody
            rows={rows}
            scrollThreshold={scrollThreshold}
            isScrollable={isScrollable}
            {...rest}
          />
        </table>
      </div>
      {children}
    </>
  )
}
